import { render, staticRenderFns } from "./MobileCenterTab.vue?vue&type=template&id=5336e11c&"
import script from "./MobileCenterTab.vue?vue&type=script&lang=js&"
export * from "./MobileCenterTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports